import { render, staticRenderFns } from "./checkText.vue?vue&type=template&id=9989046c&scoped=true"
import script from "./checkText.vue?vue&type=script&lang=js"
export * from "./checkText.vue?vue&type=script&lang=js"
import style0 from "./checkText.vue?vue&type=style&index=0&id=9989046c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9989046c",
  null
  
)

export default component.exports